/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useEffect, useState} from 'react'
import {Link} from 'react-router-dom'
import {KTSVG} from '../../../_metronic/helpers'
import {useDispatch, useSelector} from 'react-redux'
import useUtils from './useUtils'
import {Badge} from 'react-bootstrap'
import { setTitle } from '../../redux/reducers/mainSlice'
import EditCohort from './EditCohort'
import DeleteConfirmation from '../../modules/alert/DeleteConfirmation'
import Pagination from '../../modules/pagination/Pagination'
import TableSkeleton from '../../modules/skeleton/TableSkelton'

const CohortList = ({className}) => {
  const [loading, setLoading] = useState(true)
  const [show, setShow] = useState(false)
  const [editable, setEditable] = useState({})
  const {fetchCohort, deleteCohort} = useUtils()
  const dispatch = useDispatch()
  const [cohort, setCohort] = useState()
  const [currentCohort, setCurrentCohort] = useState("");

   const [page, setPage] = useState(1)
    const [limit, setLimit] = useState(10)
    const [totalPages, setTotalPages] = useState(1)
  
    const [modalVisible, setModalVisible] = useState(false)
    const [selectedId, setSelectedId] = useState(null)

  dispatch(setTitle('Cohort'))

  const getCohort = async () => {
    try {
      setLoading(true)
      const offset = (page - 1) * limit
      const result = await fetchCohort(limit, offset)
      setTotalPages(Math.ceil(result?.count / limit))
      setCohort(result)
    } catch (error) {
    } finally {
      setLoading(false)
    }
  }

  const handleDelete = (id) => {
    setSelectedId(id)
    setModalVisible(true)
  }

  const confirmDelete = async () => {
    if (!selectedId) return
    try {
      setLoading(true)
      const result = await deleteCohort(selectedId, limit, (page - 1) * limit)
      setCohort(result)
    } catch (error) {
      console.error('Error deleting Cohort:', error)
    } finally {
      setLoading(false)
      setModalVisible(false)
      setSelectedId(null)
    }
  }

  useEffect(() => {
    getCohort()
  }, [limit, page])

  useEffect(() => {

    if (cohort?.records.length > 0) {
      console.log(cohort)
      const activeCohort = cohort.records.find((val) => val.isActive === true);
      if (activeCohort) {
        setCurrentCohort(activeCohort.title);
      }
    }
  }, [cohort]);
 
  if (loading) return <TableSkeleton/>
  return (
    <>
      <div className='d-flex justify-content-between align-items-start px-3 mb-5'>
        <div className='align-items-center'>
          <div className='t-16 fw-500'>Cohort</div>
          <div className='d-flex align-items-center gap-1 t-12 fw-400'>
            {' '}
            <svg
              xmlns='http://www.w3.org/2000/svg'
              width='14'
              height='14'
              fill='currentColor'
              class='bi bi-info-circle'
              viewBox='0 0 16 16'
            >
              <path d='M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16' />
              <path d='m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0' />
            </svg>{' '}
            Only one cohort to be active at a time
          </div>
        </div>
        <div className='d-flex gap-2 align-items-center'>
          <div>
            <Link to='/cohortlist/addcohort'>
              <div type='button' className='btn btn-primary'>
                <KTSVG path='/media/icons/duotune/arrows/arr075.svg' className='svg-icon-2' />
                Add Cohort
              </div>
            </Link>
          </div>
        </div>
      </div>

      <div className={`card ${className}`}>
        {/* begin::Header */}
        <div className='card-header pt-5'>
          <div>
            <h3 className='card-title align-items-start flex-column'>
              <span className='card-label fw-bold fs-3'>Active Cohort</span>
            </h3>
            {/* begin::Search */}
          </div>
          
        </div>
        {/* end::Header */}
        {/* begin::Body */}
        <div className='card-body pb-8'>
          {/* begin::Table container */}
          {cohort?.records &&
            cohort?.records
              ?.filter((val) => val.isActive === true)
              .map((val, index) => {
                return (
                  <div key={index} className='d-flex justify-content-between  px-3'>
                    <Badge bg='success' className='fs-5 fw-semibold'>
                      {val.title}
                    </Badge>
                    <Badge bg='danger' className='fs-5 fw-semibold'>
                      {`${
                        !isNaN(Number(val.startDate))
                          ? new Date(Number(val.startDate)).toISOString().split('T')[0]
                          : 'Invalid Start Date'
                      } To ${
                        !isNaN(Number(val.endDate))
                          ? new Date(Number(val.endDate)).toISOString().split('T')[0]
                          : 'Invalid End Date'
                      }`}
                    </Badge>{' '}
                  </div>
                )
              })}
          {/* end::Table container */}
        </div>
        {/* begin::Body */}
      </div>

      <div className={`card ${className}`}>
        {/* begin::Header */}
        <div className='card-header border-0 pt-5'>
          <div className='d-flex align-items-center gap-10'>
            <h3 className='card-title align-items-start flex-column'>
              <span className='card-label fw-bold fs-3 mb-1'>In Active Cohort</span>
              <span className='class-label mt-1 text-muted fs-7'>{cohort?.count-1} Items</span>
            </h3>
            {/* begin::Search */}
          </div>
     
        </div>
        {/* end::Header */}
        {/* begin::Body */}
        <div className='card-body py-3'>
          {/* begin::Table container */}
          <div className='table-responsive'>
            {/* begin::Table */}
            <table className='table table-row-bordered table-row-gray-100 align-middle gs-0 gy-3'>
              {/* begin::Table head */}
              <thead>
                <tr className='fw-bold text-muted'>
                  <th className='min-w-100px '>ID</th>
                  <th className='min-w-100px '>COHORT</th>
                  <th className='min-w-100px '>START DATE</th>
                  <th className='min-w-100px '>END DATE</th>
                  <th className='min-w-100px text-end'>ACTIONS</th>
                </tr>
              </thead>
              {/* end::Table head */}
              {/* begin::Table body */}
              <tbody>
                {cohort?.records &&
                  cohort?.records
                    ?.filter((val) => val.isActive !== true)
                    .map((val, index) => {
                      return (
                        <tr key={index}>
                          <td className='text-nowrap'>
                            <a href='#' className='text-dark fw-bold fs-6'>
                              {val.id}
                            </a>
                          </td>
                          <td>
                            <a href='#' className='text-dark  fw-bold  fs-6'>
                              {val.title}
                            </a>
                          </td>
                          <td>
                            <a
                              href='#'
                              className='text-dark fw-bold  d-block mb-1 fs-6'
                            >
                              {new Date(Number(val?.startDate)).toISOString().split('T')[0]}
                            </a>
                            {/* <span className='text-muted fw-semibold text-muted d-block fs-7'>Code: BY</span> */}
                          </td>
                          <td>
                            <a
                              href='#'
                              className='text-dark fw-bold   d-block mb-1 fs-6'
                            >
                              {new Date(Number(val?.endDate)).toISOString().split('T')[0]}
                            </a>
                            {/* <span className='text-muted fw-semibold text-muted d-block fs-7'>Code: Paid</span> */}
                          </td>
                          <td className='text-end'>
                          
                            <span 
                            onClick={()=>{
                              setEditable(val)
                              setShow(true)}}
                            className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'>
                              <KTSVG
                                path='/media/icons/duotune/art/art005.svg'
                                className='svg-icon-3 svg-icon-primary'
                              />
                            </span>
                            <span 
                            onClick={()=>handleDelete(val?.id)}
                            className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'>
                              <KTSVG
                                path='/media/icons/duotune/general/gen027.svg'
                                className='svg-icon-3 text-danger'
                              />
                            </span>
                          </td>
                        </tr>
                      )
                    })}
              </tbody>
              {/* end::Table body */}
            </table>
            {/* end::Table */}
          </div>
          {/* end::Table container */}
        
        </div>
        <div className='d-flex align-items-center justify-content-between pb-5 ps-10 pe-5'>
          <div className='d-flex align-items-center gap-3'>
            <span className='fs-6 text-muted'>Show</span>
            <div>
              <select
                defaultValue={limit}
                className='form-select form-select-solid text-muted select2-hidden-accessible'
                onChange={(e) => {
                  setPage(1)
                  setLimit(e.target.value)
                }}
              >
                <option>10</option>
                <option>20</option>
                <option>50</option>
                <option>100</option>
              </select>
            </div>
          </div>
          <DeleteConfirmation
            isVisible={modalVisible}
            message='Are you sure you want to delete Cohort?'
            onConfirm={confirmDelete}
            onCancel={() => setModalVisible(false)}
          />
          <Pagination currentPage={page} totalPages={totalPages} onPageChange={setPage} />
        </div>
        {/* begin::Body */}
      </div>
      <EditCohort show={show} handleClose={() => setShow(false)}  cohort={editable} currentCohort={currentCohort} setCohort={getCohort}/>
    </>
  )
}

export default CohortList
